import * as Yup from "yup";

export const formSchema = Yup.object().shape({
  reason: Yup.string().required("Reason is required"),
});
